/**
 * Default shapes for Vuex user/auth state.
 * Kept separate from utilities.js to avoid circular import: store ↔ utilities.
 */
export function initAuthentication() {
  return {
    idToken: '',
    group: '',
    logined: false,
  }
}

export function initUser() {
  return {
    id: '',
    name: '',
    type: 0, // 1: client, 2: branch admin, 3: RH admin, 4: RH financial admin, 5: specialist, 6: super admin, 7: practice manager
    typeName: '',
    status: false,
    clientId: 0,
    specialistId: 0,
    practiceManagerID: null,
    lastLoggedInDate: '',
    email: '',
    phone: '',
    list: [],
  }
}
